export default {
  trigger: 'Inviter restaurantejer',
  title: 'Inviter restaurantejeren',
  description:
    'Opret en konto til restaurantejeren. Vedkommende modtager en e-mail med en midlertidig adgangskode til at logge ind og gøre restauranten klar.',
  fields: {
    first_name: 'Fornavn',
    last_name: 'Efternavn',
    email: 'E-mail',
  },
  buttons: {
    invite: 'Send invitation',
    cancel: 'Annuller',
  },
  toasts: {
    invited: '{{email}} er blevet inviteret til at fuldføre opsætningen.',
    failed: 'Ejerkontoen kunne ikke oprettes. Prøv igen.',
  },
};
